import { render, staticRenderFns } from "./retureQuantity.vue?vue&type=template&id=96043cb6&scoped=true"
import script from "./retureQuantity.vue?vue&type=script&lang=js"
export * from "./retureQuantity.vue?vue&type=script&lang=js"
import style0 from "./retureQuantity.vue?vue&type=style&index=0&id=96043cb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96043cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96043cb6')) {
      api.createRecord('96043cb6', component.options)
    } else {
      api.reload('96043cb6', component.options)
    }
    module.hot.accept("./retureQuantity.vue?vue&type=template&id=96043cb6&scoped=true", function () {
      api.rerender('96043cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/retureQuantity.vue"
export default component.exports